import React, { useCallback, useState, useMemo } from "react";
import CaseList from "../components/sections/CaseList";
import { debounce } from "lodash";
import Dropdown from "../components/elements/Dropdown";
import HelmetWrapper from "../components/sections/HelmetWrapper";
import { caseStudyMetaData } from "../seo/metaDeta";
const caseStudies = [
  {
    category: "Fintech",
    heading: "Why Growpital Choose Datazip, an All-in-One Data Platform",
    subHeading:
      "Growpital is a platform that connects investors with agriculture projects that offer a balance of high returns and low risk. It provides investors with a way...",
    img: require("../assets/images/growpital_case.png"),
    link: "https://datazip.io/blog/why-growpital-choose-datazip-an-all-in-one-data-platform/",
  },
  {
    category: "SaaS",
    heading:
      "How Datazip Scaled Topmate’s Analytics That Drove Customer Engagement",
    subHeading:
      "Topmate enables professionals to handle requests for personal advice or guidance effortlessly by allowing others to initiate a one-on-one interaction while...",
    img: require("../assets/images/topmate_case.png"),
    link: "https://datazip.io/blog/how-datazip-scaled-topmates-analytics-that-drove-customer-engagement/",
  },
  {
    category: "Ecommerce",
    heading: "How Skyber Attained Peace of Mind with Datazip",
    subHeading:
      "Skyber is an Enterprise SaaS and B2B Commerce platform that aims to digitalize, optimize and streamline business transactions by bringing multiple stakeholders...",
    img: require("../assets/images/skyber_case.png"),
    link: "https://datazip.io/blog/how-skyber-attained-peace-of-mind-with-datazip/",
  },
  {
    category: "healthtech",
    heading:
      "How Datazip's Platform Improved NirogGyan’s Health Data Understanding",
    subHeading:
      "NirogGyan™ is a Patient Engagement SaaS for Healthcare Providers that aims to bring their patients back to them with innovative data-based health tech products like...",
    img: require("../assets/images/niroggyan_case.png"),
    link: "https://datazip.io/blog/how-datazips-platform-improved-niroggyans-health-data-understanding/",
  },
];
const CaseStudy = () => {
  const [filterParam, setFilterParam] = useState();
  const [selected, setSelected] = useState([]);
  const handleChange = debounce(
    useCallback((e) => {
      setFilterParam(e);
    }, []),
    500
  );
  const filteredStudies = useMemo(
    () =>
      filterParam || selected.length
        ? caseStudies.filter(
            (src) =>
              src.heading.toLowerCase().includes(filterParam?.toLowerCase()) ||
              selected.some((el) => el?.name?.toLowerCase() === src.category)
          )
        : caseStudies,
    [filterParam, selected]
  );

  return (
    <>
    <HelmetWrapper {...caseStudyMetaData}/>
      <div className="container">
        <div className="case__container">
          <div className="case__text-container">
            <div className="case__text-tag">Customer success stories</div>
            <div className="case__text-heading">Case Studies</div>
            <div className="case__text-sub">
              Here's what our users and customers have to say about Datazip.
            </div>
          </div>
        </div>
        <div className="divider" />
      </div>
      <div className="container case">
        <div className="case__left">
          <div className="connector__search" data-reveal-delay="400">
            <img
              src={require("../assets/images/search.svg")}
              alt="search_img"
            />
            <input
              className="search-input"
              placeholder="Search"
              onChange={(e) => {
                const {
                  target: { value },
                } = e;
                handleChange(value);
              }}
            />
          </div>
          <div className="dropdown__box">
            <Dropdown selected={selected} setSelected={setSelected} />
          </div>
        </div>
        <div className="case__right">
          <CaseList caseStudies={filteredStudies} />
        </div>
      </div>
    </>
  );
};

export default CaseStudy;
